import { computed, Injectable, signal } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private readonly _sessionUuid = signal('');
  readonly sessionUuid = computed(() => this._sessionUuid());

  constructor() {
    this.createSessionUuid();
  }

  private createSessionUuid(): void {
    this._sessionUuid.set(uuidv4());
  }
}
